// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lgR2","top":"styles_top__1oMAz","left":"styles_left__2-tnl","description":"styles_description__3ftbs"};